// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WALL_GROWL_SUBSCRIBED_TO_CONTEST_ANNOUNCEMENT = "Upozorn\u011bn\u00ed <strong>zapnut\u00e9</strong>. Odte\u010f t\u011b budeme informovat o nov\u00fdch sout\u011b\u017e\u00edch.";
export const WALL_GROWL_UNSUBSCRIBED_FROM_CONTEST_ANNOUNCEMENT = "Upozorn\u011bn\u00ed <strong>vypnut\u00e9</strong>. U\u017e t\u011b nebudeme informovat o nov\u00fdch sout\u011b\u017e\u00edch.";
